import React from 'react';
import { fb, twitter, instagram, linkedin, youtube } from "../../assets"
import Divider from '@mui/material/Divider';

export default function Footer() {
    return (
        <>
            {/* First div - Hide on mobile view */}
            <div className="hidden md:block" style={{
                marginTop: "54px",
                background: 'transparent linear-gradient(125deg, #1D0534 0%, #31197C 37%, #916CF3 100%) 0% 0% no-repeat padding-box',
                opacity: 1,
            }}>
                {/* Content of the first div */}
                <div
                    style={{
                        marginTop: "54px",
                        background:
                            'transparent linear-gradient(125deg, #1D0534 0%, #31197C 37%, #916CF3 100%) 0% 0% no-repeat padding-box',
                        opacity: 1,
                    }}
                    className="bg-gray-800 text-white py-4"
                >
                    <div className="container mx-auto flex justify-between items">
                        {/* Left side content: Follow Us and Social Icons */}
                        <div className="text-sm">
                            <div style={{ fontFamily: "sfpromedium", fontSize: "16px" }} className="mb-2">
                                <span>Follow Us on:</span>
                            </div>
                            <div className="flex items-center mb-2">
                                <div className="socialIcons mr-2">
                                    <ul className="flex">
                                        <li className="mr-3">
                                            <a href="https://www.facebook.com/shiprocket" target="_blank" rel="noopener noreferrer">
                                                <img src={fb} alt="Facebook" />
                                            </a>
                                        </li>
                                        <li className="mr-3">
                                            <a href="https://twitter.com/shiprocketindia" target="_blank" rel="noopener noreferrer">
                                                <img src={twitter} alt="Twitter" />
                                            </a>
                                        </li>
                                        <li className="mr-3">
                                            <a href="https://www.instagram.com/shiprocket.in" target="_blank" rel="noopener noreferrer">
                                                <img src={instagram} alt="Instagram" />
                                            </a>
                                        </li>
                                        <li className="mr-3">
                                            <a href="https://www.youtube.com/c/Shiprocketdotin" target="_blank" rel="noopener noreferrer">
                                                <img src={youtube} alt="YouTube" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://in.linkedin.com/company/shiprocket" target="_blank" rel="noopener noreferrer">
                                                <img src={linkedin} alt="LinkedIn" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Right side content: About Us, FAQs, etc. */}
                        <div className='container flex justify-end'>
                            <div style={{ fontSize: "15px", gap: "20px" }} className="text-sm mb-1">
                                <div style={{ display: 'flex', gap: '18px' }} >
                                    <a
                                        href="https://www.shiprocket.in/about-us/"
                                        style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        About Us
                                    </a>{' '}

                                    <a
                                        href="https://www.shiprocket.in/faq/"
                                        style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        FAQs
                                    </a>{' '}

                                    <a
                                        href="https://www.shiprocket.in/blog/"
                                        style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Blogs of the week
                                    </a>

                                    <a
                                        href="https://www.shiprocket.in/partners/"
                                        style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Partnership Details
                                    </a>
                                    {' '}

                                    <a
                                        href="https://www.shiprocket.in/developers/"
                                        style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Developer Resources
                                    </a>{' '}


                                </div>

                            </div>
                        </div>

                    </div>
                    <div className='container' >
                        < Divider sx={{ marginTop: "15px", borderColor: "rgb(148, 123, 218)", height: "1px" }} />
                    </div>
                    {/* Copyright line */}
                    <div style={{ fontSize: "14px" }} className="container mx-auto text-sm mt-6 flex justify-between">
                        <span>© 2024 Shiprocket. All Rights Reserved.</span>
                        <div style={{ display: 'flex' }}>
                            <a href="https://www.shiprocket.in/privacy-policy/" style={{ marginRight: '18px' }}>Privacy Policy</a>
                            <a href="https://www.shiprocket.in/privacy-policy/" style={{ marginRight: '18px' }}>Terms of Use</a>

                        </div>
                    </div>

                </div>
            </div>

            {/* Second div - Show on mobile view */}
            <div className="block md:hidden" style={{
                height: '300px',
                fontFamily: "SF Pro Display, sans-serif",
                background: 'transparent linear-gradient(125deg, #1D0534 0%, #31197C 37%, #916CF3 100%) 0% 0% no-repeat padding-box',
                opacity: 1,
            }}>
                {/* Content of the second div */}
                <div
                    style={{
                        height: '300px',
                        fontFamily: "SF Pro Display, sans-serif",
                        background:
                            'transparent linear-gradient(125deg, #1D0534 0%, #31197C 37%, #916CF3 100%) 0% 0% no-repeat padding-box',
                        opacity: 1,
                    }}
                    className="bg-gray-800 text-white py-4">
                    <div className="container mx-auto  justify-between items-center">
                        <div style={{ textAlign: 'center', marginTop: '22px' }}>
                            {/* Add additional content or links here */}
                            <div
                                className="text-sm"
                                style={{
                                    fontFamily: 'SF Pro Display, sans-serif',
                                    fontWeight: 400,
                                    color: '#F0F0F0',
                                    lineHeight: '1.5',
                                    cursor: 'pointer', // Add cursor pointer to indicate it's clickable
                                }}
                            >
                                <a
                                    href="https://www.shiprocket.in/about-us/"
                                    style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    About Us
                                </a>{' '}
                                |{' '}
                                <a
                                    href="https://www.shiprocket.in/faq/"
                                    style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    FAQs
                                </a>{' '}
                                |{' '}
                                <a
                                    href="https://www.shiprocket.in/partners/"
                                    style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Partnership Details
                                </a>{' '}
                                |{' '}

                            </div>
                            <div>

                                <a
                                    href="https://www.shiprocket.in/developers/"
                                    style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Developer Resources
                                </a>{' '}
                                |{' '}
                                <a
                                    href="https://www.shiprocket.in/blog/"
                                    style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Blogs of the week
                                </a>
                            </div>

                            {/* Add a margin-top to create a gap */}
                            <div className="text-sm" style={{ marginTop: '20px' }}>
                                Follow Us on.
                            </div>



                        </div>
                        <div className="socialIconsMob">
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/shiprocket" target="_blank" rel="noopener noreferrer">
                                        <img src={fb} alt="Facebook" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/shiprocketindia" target="_blank" rel="noopener noreferrer">
                                        <img src={twitter} alt="Twitter" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/shiprocket.in" target="_blank" rel="noopener noreferrer">
                                        <img src={instagram} alt="Instagram" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/c/Shiprocketdotin" target="_blank" rel="noopener noreferrer">
                                        <img src={youtube} alt="YouTube" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://in.linkedin.com/company/shiprocket" target="_blank" rel="noopener noreferrer">
                                        <img src={linkedin} alt="LinkedIn" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <div className="text-sm" style={{ marginTop: '20px' }}>
                                Legal Links
                            </div>
                            <div className="text-sm" style={{ marginTop: '10px' }}>
                                <a
                                    href="https://www.shiprocket.in/privacy-policy/"
                                    style={{ color: '#F0F0F0', textDecoration: 'none' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy | Terms of Use
                                </a>

                            </div>
                            <div className="text-sm" style={{ marginTop: '30px' }}>
                                © 2024 Shiprocket. All Rights Reserved.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>



    )
}


